module.exports = __webpack_public_path__ + "images/category_lp/watch/main-view_a5208588dbdcc50adf5f2b057d51c4ed.png";